import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import VizSensor from 'react-visibility-sensor';
import { withRouter } from 'react-router-dom'
import { format } from 'date-fns';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import BrokenImageIcon from '@material-ui/icons/BrokenImage';
import Moments from 'app/screens/Moments';
import config from 'shared/config/config';
import './style.scss';

import {
  getAvailableMoments
} from 'shared/selectors/cartSelectors'

import {
  showMobileCartPremiumGallery,
  getPurchaseCalculations,
  getSelections,
  getMoments,
  setPremiumGalleryLoaded
} from 'shared/actions/cartActions'

import {
  setPhotoSwipeItems
} from 'shared/actions/photoSwipeActions'

import {
  openCartStory,
  fetchStripeSettings,
  fetchAccountSettings
} from 'shared/actions/storyActions'

const windowWidth = window.innerWidth;
const fullCardWidth = windowWidth * 0.75;
const cardWidth = (fullCardWidth < 300 ? fullCardWidth : 300) + 'px';

const styles = theme => ({
  media: {
    height: 300,
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  cardLabel: {
    fontSize: '1rem',
    padding: '10px',
    fontWeight: '400 !important',
    fontFamily: config.sub_font
  },
  cardLabelBg: {
    margin: '0 auto',
    maxWidth: 'calc(100% - 30px)',
    padding: '10px',
    background: config.pwa_card_label_bg_color,
    border: '2px solid ' + config.pwa_card_label_border_color,
    boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    borderRadius: '3px',
    color: config.pwa_galleryimage_font_color
  }
});

class MobileCartStory extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      loaded: false
    }
  }

  componentDidMount() {
    // if (this.props.deeplink) {
    //   this.open();
    // }

    if (((this.props.deeplink && this.props.deeplinkStoryId) || this.props.openPremiumStory)) {
      this.handleShowPremiumGallery();
    }
  }

  shouldComponentUpdate(newProps, newState) {
    return this.state.visible !== newState.visible ||
      this.state.loaded !== newState.loaded ||
      this.props.isMobileCart !== newProps.isMobileCart ||
      this.props.availableMoments !== newProps.availableMoments ||
      this.props.deeplinkStoryId !== newProps.deeplinkStoryId;
  }

  componentDidUpdate() {
    // hotfix
    window.CL = window.CL || {};
    window.CL.storyComponents = window.CL.storyComponents || {};
    window.CL.storyComponents[this.props.story.id] = this;
  }

  progress = () => {
    const { imageLoadProgress } = this.state;
    this.setState({ imageLoadProgress: imageLoadProgress >= 100 ? 0 : imageLoadProgress + 10 });
  }

  getDates() {
    const formatStr = 'MMMM d, y';
    const story = this.props.story;

    if (story.start_date && story.end_date) {
      let start = format(new Date(story.start_date), formatStr);
      let end = format(new Date(story.end_date), formatStr);

      if (start !== end) {
        return `${start} - ${end}`;
      }

      return start;
    }

    return format(new Date(story.createdAt), formatStr);
  }

  renderCardMedia = (classes) => {
    const { story } = this.props;

    if (story.cover_moment_thumb) {
      var imgStyle;
      if (story.cover_moment && story.cover_moment.height > story.cover_moment.width) {
        imgStyle = {
          width: '100%',
          height: 'auto',
          opacity: this.state.visible ? 1 : 0,
          transition: 'opacity 0.5s'
        }
      } else {
        imgStyle = {
          width: 'auto',
          height: '100%',
          opacity: this.state.visible ? 1 : 0,
          transition: 'opacity 0.5s'
        }

      }

      return (
        <CardContent
          className={classes.media}
          // image={this.props.story.cover_moment_thumb}
          src=""
          title={this.props.story.name}
          style={{
            height: "100%",
            width: "100%",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
            padding: "0px",
            background: config.pwa_story_bg,
            overflow: 'hidden'
          }}
        >
          <VizSensor
            partialVisibility
            onChange={isVisible => {
              if (isVisible && !this.state.visible) {
                this.setState({ visible: true });
              }
            }}>
            <img
              src={(this.state.loaded && this.props.story.cover_moment_cart) || (this.state.visible && this.props.story.cover_moment_cart) || ''}
              style={imgStyle}
              alt={this.props.story.name}
              onLoad={() => {
                this.setState({ loaded: true })
              }}
              onError={() => {
                // console.log("image error for story: ", this.props.story.id);
                // this.setState({imageLoaded: true});
                //clearInterval(this.timer);
              }}
            />
          </VizSensor>
        </CardContent>
      );
    } else if (!this.props.story.cover_moment_thumb && !this.props.story.cover_moment_error) {
      // clearInterval(this.timer);
      return (
        <CardContent
          style={{ height: "100%", width: "100%", flex: 1, flexDirection: "column", alignItems: "center" }}
        >
          <div style={{ marginTop: "50px" }}>
            <CircularProgress
              className={classes.progress}
              variant="determinate"
              value={this.state.imageLoadProgress}
            />
          </div>
        </CardContent>
      );
    } else if (!this.props.story.cover_moment_thumb && this.props.story.cover_moment_error) {
      // clearInterval(this.timer);
      return (
        <CardContent
          style={{ height: "100%", width: "100%", flex: 1 }}
        >
          <BrokenImageIcon style={{ marginTop: "40px", fill: "lightgray", fontSize: "100px" }} />
        </CardContent>
      );
    }
  }

  handleShowPremiumGallery = async () => {
    const { getMoments, getSelections, showMobileCartPremiumGallery, openCartStory,
      user, story, getPurchaseCalculations, fetchStripeSettings, accountSettings, fetchAccountSettings, setPremiumGalleryLoaded } = this.props;

    showMobileCartPremiumGallery(true);

    getMoments('', story.id, { includePurchased: false }).then(async (moments) => {
      this.loadPhotoSwipeItems(moments);
      fetchStripeSettings(story.id);

      if (!accountSettings[story.id]) {
        fetchAccountSettings(story.id, null)
      }

      await getPurchaseCalculations(story.id, moments.length);
      getSelections(story.id);
      openCartStory(user, story);
      setPremiumGalleryLoaded(true);
    })
  }

  loadPhotoSwipeItems(moments) {
    moments = moments && moments.length > 0 ? moments : this.props.availableMoments;

    let items = moments.map((m) => {
      return {
        id: m.id,
        position: m.position,
        src: m.preview_url,
        w: m.width,
        h: m.height,
        purchased: m.purchased
      };
    });

    // append "unpurchased" to story ID for Photoswipe isolation
    let storyId = `${this.props.story.id}-unpurchased`;
    this.props.setPhotoSwipeItems(storyId, items);
  }

  render() {
    const { classes, user, story, isMobileCart } = this.props;

    const content = (
      <Moments story={story} />
    );

    const button = (
      <Card className="card-wrapper" style={{ margin: 'auto', borderRadius: '5px', width: cardWidth, height: cardWidth, opacity: 1 }}>
        <div className="card">
          {this.renderCardMedia(classes)}
          <CardActions className={classes.actions}
            style={{ display: 'block' }}
          >
            <div className="card-label-wrapper">
              <div className={classes.cardLabelBg}>
                <Typography variant="h4" component="h4" className={classes.cardLabel} style={{ display: 'inline' }}>
                  <b>{story.name}</b> ({story.purchased_count})
                </Typography>
              </div>
            </div>
          </CardActions>
        </div>
      </Card>
    );

    const props = {
      user,
      story,
      content,
      button,
      openDuration: 1500,
      closeDuration: 300,
      rubberband: 50
    }

    return (
      <Card className="card-wrapper" style={{ margin: 'auto', borderRadius: '5px', width: cardWidth, height: cardWidth, opacity: 1 }}
        onClick={this.handleShowPremiumGallery.bind(this)}>
        <div className="card">
          {this.renderCardMedia(classes)}
          <CardActions className={classes.actions}
            style={{ display: 'block' }}
          >
            <div className="card-label-wrapper">
              <div className={classes.cardLabelBg}>
                <Typography variant="h4" component="h4" className={classes.cardLabel} style={{ display: 'inline' }}>
                  <b>{story.name}</b> ( {isMobileCart ? story.premium_count : story.purchased_count})
                </Typography>
              </div>
            </div>
          </CardActions>
        </div>
      </Card>
    )
  }
}

MobileCartStory.propTypes = {
  classes: PropTypes.object.isRequired,
  story: PropTypes.object.isRequired,
  // Injected by the documentation to work in an iframe.
  // You won't need it on your project.
  container: PropTypes.object,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  accountSettings: state.storyReducer.accountSettings,
  user: state.userReducer.user,
  modals: state.modalReducer.modals,
  isMobileCart: state.cartReducer.isMobileCart,
  availableMoments: getAvailableMoments(state),
  deeplinkStoryId: state.storyReducer.deeplinkStoryId,
  stripeSettings: state.storyReducer.stripeSettings,
  discountCouponApplied: state.cartReducer.discountCouponApplied,
  discountCoupon: state.cartReducer.discountCoupon
});

const StoryComponent = withStyles(styles, { withTheme: true })(MobileCartStory)

export default connect(mapStateToProps, {
  fetchStripeSettings, getSelections, getPurchaseCalculations, setPhotoSwipeItems,
  openCartStory, getMoments, showMobileCartPremiumGallery, fetchAccountSettings, setPremiumGalleryLoaded
})(withRouter(StoryComponent));
